const formatToOptions = (format) => {
  let options;

  switch (format) {
    case 'L':
      options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      break;
    case 'LL':
      options = { year: 'numeric', month: 'long', day: 'numeric' };
      break;
    case 'll':
      options = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      };
      break;
    case 'L LT':
      options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      };
      break;
    case 'LT':
      options = {
        hour: '2-digit',
        minute: '2-digit',
      };
      break;
    case 'LLLL':
      options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      };
      break;
    case 'LL LT':
      options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      };
      break;
    default:
      options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      };
      break;
  }

  return options;
};

export default formatToOptions;
